package com.gastoncantera.intercom.auth

actual object WelcomeStore {
    actual val supported: Boolean = false

    actual var accepted: Boolean
        get() = true
        set(_) = Unit

    actual var resetRequestCount: Int
        get() = 3
        set(_) = Unit
}
